import { useUser } from "@/hooks/firestore/user/useUser";

const usePayID = () => {
  const { user, isLoading } = useUser();

  return {
    payId: user?.payId?.id,
    isLoading,
  };
};

export { usePayID };
